import axios from 'axios';
import EventBus from './eventbus';
const LOADER_MINIMUM_RUNNING_TIME = 700;
let apiPendingTime = 0;
let pendingRequestNumber = 0;

function toggleLoader(show) {
	pendingRequestNumber += show ? 1 : -1;
	const now = +new Date();
	apiPendingTime = show ? now : now - apiPendingTime;
	let delay = show || (!show && apiPendingTime >= LOADER_MINIMUM_RUNNING_TIME) ? 0 : LOADER_MINIMUM_RUNNING_TIME - apiPendingTime;
	if (show || (!show && !pendingRequestNumber)) {
		setTimeout(() => EventBus.$emit('toggle-loader', show), delay);
	}
}

function initInterceptor() {
	axios.interceptors.request.use(
		(config) => {
			toggleLoader(true);

			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		(response) => {
			toggleLoader(false);

			return response;
		},
		(error) => {
			toggleLoader(false);

			return Promise.reject(error);
		}
	);
}

export default initInterceptor;
